import { Button } from '@absolutelabs/react-component-library';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFont from '../../../../../components/hooks/useFont';
import {
  selectButtonColor,
  selectButtonMinWidth,
  selectButtonRadius,
  selectButtonTextColor,
  selectButtonWeight,
  selectCurrPage,
  selectFieldSettings,
} from '../../../../../store/reducers/forms';

const ButtonField = ({ field }) => {
  const currPage = useSelector(selectCurrPage);
  const fieldSettings = useSelector(selectFieldSettings);
  const globalButtonColor = useSelector(selectButtonColor);
  const globalButtonTextColor = useSelector(selectButtonTextColor);
  const globalButtonRadius = useSelector(selectButtonRadius);
  const globalButtonMinWidth = useSelector(selectButtonMinWidth);
  const globalButtonWeight = useSelector(selectButtonWeight);
  const [fieldConfig, setFieldConfig] = useState({});
  const { font } = useFont('button');

  useEffect(() => {
    const currPageSettings = fieldSettings.find((o) => o.pageName === currPage);
    const config = currPageSettings?.fields?.find(
      (x) => x.field_id === field?.id
    );
    if (config) {
      setFieldConfig(config);
    }
  }, [fieldSettings, currPage, field?.id]);

  return (
    <Button
      text={fieldConfig.text || 'Button'}
      link={fieldConfig.link || '#'}
      style={fieldConfig.style || 'filled'}
      align={fieldConfig.align || 'full'}
      fullWidth={fieldConfig.fullWidth || false}
      textColor={globalButtonTextColor || '#ffffff'}
      color={globalButtonColor || '#109cf1'}
      font={font}
      fontWeight={globalButtonWeight}
      radius={globalButtonRadius}
      minWidth={globalButtonMinWidth}
    />
  );
};

export default ButtonField;
